import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import { Col, Button, Row } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'

import { promoteOrDemoteUserRedux } from '../../login/reducers/manageLogin'

class PromoteDemoteUser extends Component {

  state = {
    userToPromote: [],
    userToDemote: [],
  }


  _renderMenuItemChildren = (user, props, index) => {
    // THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON PROJECT LEAD/ANALYST TYPEAHEADS
    return [
      <div key="name" search={props.text}>
        <strong>{user.first_name} {user.last_name}</strong>
      </div>,
      <div key="email">
        <small>
          Email: {user.email ? user.email : "N/A"}
        </small>
      </div>,
    ]
  }


  changeUserToPromote = (userToPromote) => this.setState({ userToPromote })

  changeUserToDemote = (userToDemote) => this.setState({ userToDemote })

  handlePromoteOrDemote = (user, is_manager) => {
    if (user[0]) {

      user = user[0]

      let successText, errorText

      if (is_manager) {
        successText = "The user has been promoted"
        errorText = "There was an error promoting the user"
      } else {
        successText = "The user has been demoted"
        errorText = "There was an error demoting the user"
      }

      axios({
        method:"PATCH",
        url: user.url,
        headers:{"Authorization":"Bearer " + localStorage.getItem("token")},
        data: { is_manager }
      })
      .then(response => {
        swal({
          title: "Success",
          text: successText,
          icon: "success",
          button: "Continue",
        })

        this.props.promoteOrDemoteUserRedux(user.url)

        this.setState({
          userToPromote: [],
          userToDemote: [],
        })
      })
      .catch(error => {
        swal({
          title: "Error",
          text: errorText,
          icon: "error",
          button: "Continue",
        })
      })
    }
  }


  render () {

    const { userToPromote, userToDemote } = this.state

    let managers = this.props.users.filter(user => {
      return user.is_manager && user.id !== this.props.currentUser.pk && user.is_active
    })
    .sort((a ,b) => a.first_name.localeCompare(b.first_name))

    let mortals = this.props.users.filter(user => !user.is_manager && user.is_active)
    .sort((a, b) => a.first_name.localeCompare(b.first_name))

    return (
      <div id="PromoteDemoteUser">
        <h4>Promote</h4>
          <Row>
            <Col xs={8} sm={6} md={6}>
              <div>
                <Typeahead
                  id="UserToPromoteTypeahead"
                  clearButton
                  labelKey={user => `${user.first_name} ${user.last_name}`}
                  multiple={false}
                  renderMenuItemChildren={this._renderMenuItemChildren}
                  selected={userToPromote}
                  options={mortals}
                  placeholder="Select user..."
                  onChange={this.changeUserToPromote}
                />
              </div>
            </Col>
            <Col xs={4} sm={6} md={6}>
              <Button
                onClick={() => this.handlePromoteOrDemote(userToPromote, true)}
                disabled={!userToPromote.length}
                bsStyle="primary"
              >
                Promote
              </Button>
            </Col>
          </Row>

        <br/>

        <h4>Demote</h4>
        <Row>
          <Col xs={8} sm={6} md={6}>
            <div>
              <Typeahead
                id="UserToDemoteTypeahead"
                clearButton
                labelKey={user => `${user.first_name} ${user.last_name}`}
                multiple={false}
                renderMenuItemChildren={this._renderMenuItemChildren}
                selected={userToDemote}
                options={managers}
                placeholder="Select user..."
                onChange={this.changeUserToDemote}
              />
            </div>
          </Col>
          <Col xs={4} sm={6} md={6}>
            <Button
              onClick={() => this.handlePromoteOrDemote(userToDemote, false)}
              disabled={!userToDemote.length}
              bsStyle="primary"
            >
              Demote
            </Button>
          </Col>
        </Row>

      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    users: state.manageLogin.users,
    currentUser: state.manageLogin.user
  }
}

export default connect(mapStateToProps, { promoteOrDemoteUserRedux })(PromoteDemoteUser);



// WEBPACK FOOTER //
// ./src/routes/manager/components/PromoteDemoteUser.js